import { Box, Typography, Stack } from '@mui/material';
// assets
import { UploadIllustration } from '../../assets';

// ----------------------------------------------------------------------

export default function VideoBlockContent() {
  return (
    <Stack
      spacing={2}
      alignItems="center"
      justifyContent="center"
      direction={{ xs: 'column', md: 'row' }}
      sx={{ width: 1, textAlign: { xs: 'center', md: 'left' } }}
    >
      <UploadIllustration sx={{ width: 220 }} />

      <Box sx={{ p: 3 }}>
        <Typography gutterBottom variant="h5">
          Browse or Drag & Drop Video Files
        </Typography>

        {/* <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          Allowed formats *.jpg ,*.jpeg,*.png<br />
          Max Image Size 20MB
        </Typography> */}
      </Box>
    </Stack>
  );
}